'use strict';

var define = require('define-properties');

var getPolyfill = require('./polyfill');
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */


module.exports = function shimNumberIsNaN() {
  var polyfill = getPolyfill();
  define(Number, {
    isNaN: polyfill
  }, {
    isNaN: function isNaN() {
      return Number.isNaN !== polyfill;
    }
  });
  return polyfill;
};